export default __webpack_public_path__ + "static/media/rotary.b93cac89.svg";